class MiniCart extends HTMLElement {
  constructor() {
    super();
    
    ProductForm = document.querySelector('new-custom-products');
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }
  
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    window.pincode = localStorage.getItem('locationID');
    fetch(`${this.dataset.url}&location=${pincode}L`)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          var Pincode = localStorage.getItem('Pincode');
          var pinField = document.querySelectorAll('[PincodeField]');
          if(pinField.length > 0 && Pincode) {
            pinField[0].classList.remove('d-none');
            pinField[0].innerHTML = Pincode;
            document.querySelector('#cart_popup-open').innerHTML = '(Change)';
            document.querySelectorAll('.deliveryMessage')[0].innerHTML = 'Delivery to';
          }else if(pinField.length > 0 && Pincode == undefined) {
            pinField[0].classList.add('d-none');
            document.querySelector('#cart_popup-open').innerHTML = '(Add)';
            document.querySelectorAll('.deliveryMessage')[0].innerHTML = 'Enter Pincode';
          }
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
          OutofStockRemove();
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    // this.drawer.openMenuDrawer();
    var isToopen = document.querySelector('form.mini-cart');
    if(!isToopen.classList.contains('already_added')) {
      this.drawer.openMenuDrawer();
    }else {
      openPopup();
    }
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      var dd = document.getElementById(section.id);
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
      var Productslider = document.querySelectorAll('.custom_product_slider1');
      if(Productslider.length != 0) {
        Productslider.forEach((slider) => {
          new Glider(slider, getGliderSettings());
        })
      }
    }));

    this.open();
  }

  recipeRenderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
      var Productslider = document.querySelectorAll('.custom_product_slider1');
      if(Productslider.length != 0) {
        Productslider.forEach((slider) => {
          new Glider(slider, getGliderSettings());
        })
      }
    }));
  }

  getSectionsToRender() {
    let DataSet = ProductForm != null ? `${ProductForm.dataset.section}` : (`new-custom-products`);
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'custom-products',
        section: 'custom-products',
        selector: '.shopify-section',
      },
      {
        id: `${DataSet}`,
        section: document.getElementById(`${DataSet}`)?.id,
        selector: '.shopify-section',
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

function showHideDetails(t) {
  if(t.classList.contains('minimze_details')) {
    t.classList.remove('minimze_details')
  }else {
    t.classList.add('minimze_details')
  }
}

// function getGliderSettings(){
//   return {
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     arrows: {
//       prev: '.glider-prevz',
//       next: '.glider-nextz'
//     },
//     responsive:[
//       {
//         breakpoint:992,
//         settings: {
//           slidesToShow:4,
//           arrow:true
//         }
//       }
//     ]
//   }
// }